// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

const SpaClaimNumberCellRenderer = props =>
    props.value ?
        <Link
            rel='noopener noreferrer'
            target='_blank'
            to={`${buildClaimRoutes('ZSPA', '', props.value)}`}
        >
            {formatClaimNumber(props.value)}
        </Link> : null;

SpaClaimNumberCellRenderer.displayName = 'SpaClaimNumberCellRenderer';
SpaClaimNumberCellRenderer.propTypes = {
    value: PropTypes.string.isRequired
};

export default SpaClaimNumberCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/spa-claim-number-cell-renderer.js